import React, { useEffect, useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, OutlinedInput, Checkbox, ListItemText, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";

const FileConfigForm = ({scheduleData, setScheduleData, isPublished}) => {
  const fileTypes = ["CSV", "JSON", "PARQUET"];
  const fileFields = ["login_email", "first_name", "last_name", "phone_number"];
  const channel_of_communications = ["SMS", "EMAIL", "BOTH"];
  //console.log("scheduleData>>>", scheduleData);
  const [formData, setFormData] = useState({
    fileType: scheduleData?.fileType || "CSV",
    fileFields: scheduleData?.fileFields || [],
    channelOfCommunication: scheduleData?.channelOfCommunication || "BOTH",
  });
  //console.log("formData", formData);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    const obj = { 
      ...scheduleData, 
      fileType: scheduleData?.fileType || "CSV",
      fileFields: scheduleData?.fileFields || [],
      channelOfCommunication: scheduleData?.channelOfCommunication || "BOTH",
      [name]: value,
    };
    setScheduleData(obj);
  };

  useEffect(()=>{
    const obj = { 
      ...scheduleData, 
      fileType: scheduleData?.fileType || "CSV",
      fileFields: scheduleData?.fileFields || [],
      channelOfCommunication: scheduleData?.channelOfCommunication || "BOTH"
    };
    setScheduleData(obj);  
  },[]);

  
  return (
    <LocalizationProvider>
      <div className="info-container">
          <h4>All fields are optional</h4>
      </div>
      <Box sx={{ bgcolor: 'white' }}>
        {/* File Type - Single Select */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Typography variant="" color="textPrimary">File Type</Typography>
          <Select
            name="fileType"
            value={scheduleData?.fileType || formData.fileType}
            onChange={handleChange}
            disabled={isPublished}
          >
            {fileTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* File Fields - Multi Select */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Typography variant="" color="textPrimary">File Fields</Typography>
          <Select
            multiple
            name="fileFields"
            value={scheduleData?.fileFields || formData.fileFields}
            onChange={handleChange}
            renderValue={(selected) => selected.join(", ")}
            disabled={isPublished}
          >
            {fileFields.map((field) => (
              <MenuItem key={field} value={field} color="textPrimary">
                <Checkbox checked={(scheduleData?.fileFields || formData.fileFields).indexOf(field) > -1} sx={{color: "black"}}/>
                <ListItemText primary={field} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* File Channel - Single Select */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Typography variant="" color="textPrimary">Channel of Communication</Typography>
          <Select
            name="channelOfCommunication"
            value={scheduleData?.channelOfCommunication || formData.channelOfCommunication}
            onChange={handleChange}
            disabled={isPublished}
          >
            {channel_of_communications.map((channel) => (
              <MenuItem key={channel} value={channel}>
                {channel}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </LocalizationProvider>
  );
};

export default FileConfigForm;
